import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full container p-4 mx-auto" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center min-h-screen -mt-20 space-y-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-8xl" }, "404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, "The page you are looking for doesn't exist")
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Go to homepage")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_AppButton, {
        to: "/",
        rounded: false
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}